"use client";

import { SpinnerGapIcon } from "@phosphor-icons/react";
import { useT } from "./LocaleProvider";

export function TimePilotLoadingScreen() {
  const t = useT();
  return (
    <div
      className="flex h-screen flex-col items-center justify-center gap-2 text-2xl font-bold sm:text-4xl"
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <div>
        {t("loading.message")}
        <span className="animate-fade">.</span>
        <span className="animate-fade delay-500">.</span>
        <span className="animate-fade delay-1000">.</span>
      </div>
      <SpinnerGapIcon size={42} className="animate-spin-only" aria-hidden="true" />
    </div>
  );
}
